// extracted by mini-css-extract-plugin
export default {"tabContainer":"SkillProgressAssessStudentTabs_tabContainer__Uw9WH"};